import getTableRowCountForCells from '../utils/getTableRowCountForCells';
var MAX_TABLE_ROW_COUNT = 1000;
export default function canAddTableRow(editor, tableId) {
  var cells = editor.getTableCells(tableId);
  var rowCount = getTableRowCountForCells(cells);
  return rowCount < MAX_TABLE_ROW_COUNT;
}